import { withReduxProvider } from './src/components/hoc/withReduxProvider'

export const wrapRootElement = ({ element }) => withReduxProvider(element)
